import React from 'react';
import { motion } from 'framer-motion';
import { Users, BookOpen, Star, MapPin } from 'lucide-react';
export function SocialProof() {
  const stats = [{
    icon: <Users className="w-6 h-6 text-brandGreen" data-id="element-308" />,
    text: '+300 ENTRENADORES CONFÍAN'
  }, {
    icon: <BookOpen className="w-6 h-6 text-brandGreen" data-id="element-309" />,
    text: '6+6 TOMOS + BONOS'
  }, {
    icon: <Star className="w-6 h-6 text-brandGreen" data-id="element-310" />,
    text: '4.9/5 CALIFICACIÓN'
  }, {
    icon: <MapPin className="w-6 h-6 text-brandGreen" data-id="element-311" />,
    text: '🇦🇷 TODO EL PAÍS'
  }];
  return <div className="bg-navy-dark border-y border-white/10 py-4 md:py-6 px-4" data-id="element-312">
      <div className="max-w-6xl mx-auto" data-id="element-313">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-314">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-center text-center gap-2" data-id="element-315">
              {stat.icon}
              <span className="text-white font-bold text-xs md:text-base tracking-wide" data-id="element-316">
                {stat.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </div>;
}